/* eslint-disable */
window.Facedr = window.Facedr || {};
window.Facedr.Search = function() {
  if (window.Untamed.faqs) {
    var fuse = new Fuse(window.Facedr.faqs, {
        keys: ['question', 'answer'],
        minMatchCharLength: 3,
        threshold: 0.5
    });

    $('[data-faq-search]').on('keyup', function() {
        $('[data-topic]').removeClass('active');
        var $this = $(this);
        var value = $this.val();
        var result = [];
        if(value.length >= 3) {
            result = fuse.search(value);
            console.log(result);
        } else {
          $('[data-topic="all"]').addClass('active');
        }
        if(result.length > 0) {
            $('[data-faq]').hide();
            result.forEach(function(r) {
                $('[data-faq="' + r.item.id + '"]').show();
            });
        } else {
            $('[data-faq]').show();
        }
    });

    $('[data-faq-search-btn]').on('click', function(e) {
      scrollToResult();
    });

    $('[data-faq-search]').on('keypress', function(e) {
      if(e.which == 13) {
        scrollToResult();
      }
    });

    function scrollToResult() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $('#full-faqs').offset().top
      }, 2000);
    }
  }
};
/* eslint-enable */
